/* SLIDE 12 */
/* SLIDE 17 */

import React, { useEffect, useState } from 'react';
import ButtonBot from "shared/components/ButtonBot";
import SubHeader from 'shared/components/SubHeader';
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import { makeCenterLine, makeFixedLine } from 'utils/common';
import { onGetParkingTid } from "../utils/parkingUtils";
import { fetchAllParkingSpots } from 'features/parking/presentation/store/parkingSlice';
import { setSelectedSpot } from 'features/parking/presentation/store/parkingSlice';
import { setAppLoading } from '../../../shared/store/headerSlice';
import { toast } from "react-toastify";
import { DateTime } from 'luxon';
import { getUnpaidList } from '../usecases/ParkingUsecases';
import Popup from "shared/components/Popup";



function ParkingCheckResult() {
    const navigation = useNavigate();

    const dispatch = useDispatch();
    const location = useLocation();
    const { selectedSpotState } = location.state || {};

    const { carCheckIn, parkingSpots, selectedSpot } = useSelector((state) => state.parking);
    const { user } = useSelector((state) => state.auth);

    const [showPopupAlertUnpaid, setShowPopupAlertUnpaid] = useState(false);

    useEffect(() => {
        dispatch(fetchAllParkingSpots({ parkingId: user.parkingId }));
    }, [dispatch]);

    useEffect(() => {
        if (carCheckIn?.carNumber) {
            const spot = parkingSpots.find((s) => s.carNum == carCheckIn?.carNumber);
            console.log(spot, "spot");
            dispatch(setSelectedSpot(spot));
        }
    }, [parkingSpots]);

    const checkUnpaidData = async () => {
        const data = {
            // parkingId: user.parkingId,
            carNumber: carCheckIn?.carNumber,
            limit: 15,
            offset: 1,
        }
        const response = await getUnpaidList(data);
        if (response?.unpaidList?.length > 0) {
            setShowPopupAlertUnpaid(true);
        }
    }

    useEffect(() => {
        checkUnpaidData();
        // window.addEventListener('message', responseHandler);       // for Iphone
        document.addEventListener('message', handlePaymentResponse);  // for Android
        return () => document.removeEventListener('message', handlePaymentResponse);
    }, []);

    const handlePaymentResponse = (event) => {
        const msg = JSON.parse(event.data);
        try {
            if (msg.type === 'printRes') {
                if (['0000', '0021'].includes(msg.body.responseCode)) {
                    // when print success
                    dispatch(setAppLoading(false));
                    toast.success('성공했습니다.', {
                        position: "top-center",
                        autoClose: 1500,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        className: 'htToastSuccess',
                    });
                }
            }

            else if (msg.type === 'notInstalled') {
                //   dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupNice', value: true } });
                //   setLoadingPayment(false);
                dispatch(setAppLoading(false));
            }
        } catch (e) {
            console.error('Fail to parse message:', e);
        }
    };

    // Handle print form
    const sendEvidencePaper = async () => {
        try {

            const encoder = new TextEncoder(); // 기본 utf-8

            const form = [
                0x1B, 0x40,         // 명령 초기화

                0x1D, 0x21, 0x11,   // 크기 크게
                ...encoder.encode(makeCenterLine('[ 입 차 증 ]', true)), 0x0A,
                0x1D, 0x21, 0x00,   // 크기 초기화

                0x1D, 0x21, 0x11,   // 크기 크게
                ...encoder.encode('-'.repeat(24)), 0x0A,
                0x1D, 0x21, 0x00,   // 크기 초기화
                0x0A,

                0x1D, 0x21, 0x11,   // 크기 크게
                ...encoder.encode(makeFixedLine('구획번호:', selectedSpot?.spaceNumber, true)), 0x0A,
                0x1D, 0x21, 0x00,   // 크기 초기화

                0x1D, 0x21, 0x11,   // 크기 크게
                ...encoder.encode(makeFixedLine('차량번호:', selectedSpot?.carNum, true)), 0x0A,
                0x1D, 0x21, 0x00,   // 크기 초기화

                0x1D, 0x21, 0x11,   // 크기 크게
                ...encoder.encode(makeFixedLine('관리자번호:', user?.mobilePhone, true)), 0x0A,
                0x1D, 0x21, 0x00,   // 크기 초기화
                0x0A,

                ...encoder.encode(makeFixedLine('입차시간:', DateTime.fromFormat(selectedSpot.inTime, "yyyyMMddHHmmss").toFormat("yyyy-MM-dd HH:mm"))), 0x0A,
                ...encoder.encode(makeFixedLine('주차장소:', user?.parking?.parkingName)), 0x0A,
                ...encoder.encode(makeFixedLine('사업자번호:', window.APP_CONFIG?.bizRegNo || '')), 0x0A,
                ...encoder.encode(makeFixedLine('주차문의:', user?.parking?.phoneNumber,)), 0x0A,

                0x1D, 0x21, 0x11,   // 크기 크게
                ...encoder.encode('-'.repeat(24)), 0x0A,
                0x1D, 0x21, 0x00,   // 크기 초기화
                0x0A,

                0x1D, 0x21, 0x11,   // 크기 크게
                ...encoder.encode(' '.repeat(2) + '근무자 휴식시간 안내'), 0x0A,
                0x1D, 0x21, 0x00,   // 크기 초기화
                0x0A,

                ...encoder.encode('* 현장근무자 휴식시간 및 전화가 꺼져있는 경우'), 0x0A,
                ...encoder.encode('하단 관리자번호로 차량번호 필수 작성 후 문자 보내주세요.'), 0x0A,
                ...encoder.encode('* 주차요금 계좌번호 등 문자 전송해 드립니다.'), 0x0A,

                0x1D, 0x21, 0x11,   // 크기 크게
                ...encoder.encode('-'.repeat(24)), 0x0A,
                0x1D, 0x21, 0x00,   // 크기 초기화
                0x0A,

                0x1D, 0x21, 0x11,   // 크기 크게
                ...encoder.encode(' '.repeat(3) + '미납요금 납부방법'), 0x0A,
                0x1D, 0x21, 0x00,   // 크기 초기화
                0x0A,

                ...encoder.encode('송파구시설관리공단 공영주차부 홈페이지'), 0x0A,
                0x1D, 0x21, 0x11,   // 크기 크게
                ...encoder.encode('(www.songpagongdanpark2.or.kr)'),
                0x1D, 0x21, 0x00,   // 크기 초기화
                ...encoder.encode('미납요금 조회 및 요금을 납부하실 수 있습니다.'), 0x0A,

                0x1D, 0x21, 0x11,   // 크기 크게
                ...encoder.encode('-'.repeat(24)), 0x0A,
                0x1D, 0x21, 0x00,   // 크기 초기화
                0x0A,

                0x1D, 0x21, 0x11,   // 크기 크게
                ...encoder.encode(' '.repeat(8) + '결제문의'), 0x0A,
                0x1D, 0x21, 0x00,   // 크기 초기화
                0x0A,

                ...encoder.encode('주차관리자:' + user?.parking?.administrator), 0x0A,
                ...encoder.encode('관리자번호:' + user?.mobilePhone), 0x0A,
                ...encoder.encode('* 전화기가 꺼져있을 경우 문자 남겨주세요.'), 0x0A,

                0x1D, 0x21, 0x11,   // 크기 크게
                ...encoder.encode('-'.repeat(24)), 0x0A,
                0x1D, 0x21, 0x00,   // 크기 초기화
                0x0A,

                0x1D, 0x21, 0x11,   // 크기 크게
                ...encoder.encode(makeCenterLine('송파구시설관리공단', true)), 0x0A,
                0x1D, 0x21, 0x00,   // 크기 초기화
            ];

            const formData = new Uint8Array(form);

            const formEnc = btoa(String.fromCharCode(...formData));

            const payKey = await onGetParkingTid(user.parkingId, selectedSpot.entryId);

            if (!payKey || !payKey.tid) {
                // console.log('no tid');
                return;
            }

            // print params for VAN API
            const params = new URLSearchParams({
                billType: '9',                                // 전문종류 ( 9:프린터출력 )        
                terminalNo: payKey?.tid,                      // 단말기 번호
                // orderKey: payKey?.parkingEntryId || '99999',  // 주문번호
                orderKey: '99999',
                printResType: '1',
                resScheme: 'innodep://printResponse',         // 응답 스키마
            });

            if (window.ReactNativeWebView && window.ReactNativeWebView.postMessage) {
                window.ReactNativeWebView.postMessage(
                    JSON.stringify({ type: "print", body: params.toString(), printForm: formEnc })
                );
            } else {
                // setLoadingPayment(false);
                console.error('Cannot find Native App !!');
            }

        } catch (error) {
            console.error('Printing failed:', error);
            dispatch(setAppLoading(false));
        } finally {
            dispatch(setAppLoading(false));
        }
    }


    console.log(selectedSpot, "selectedSpot");

    return (

        <div className="htContainer nl-parking-check-result">
            <SubHeader>
                <div className="nl-row j-between col">
                    <div className={`sub-header-text w-full justify-between`}>
                        <span className="htBold">주차면 {user.parkingId}</span>
                        <span className="htBold sub-header-text-main-result">입차</span>
                    </div>

                </div>
            </SubHeader>

            <div className="htContent htHasButtonBot mt-20">

                <div className="htTextField">
                    <h4 className="nl-title-list htBold">입차정보</h4>
                </div>

                <div className="htTextField">
                    <label className="htLabel htColorGray htIrLabel">차량번호</label>
                    <span className="nl-text htIrValue">{carCheckIn?.carNumber}</span>
                </div>


                <div className="htTextField">
                    <label className="htLabel htColorGray">입차일시</label>
                    <span className="nl-text">{DateTime.fromISO(carCheckIn?.dateTime, { setZone: true }).toFormat('yyyy-MM-dd HH:mm')}</span>
                </div>

                {/* <div className="htTextField">
                    <label className="htLabel htColorGray">주차구분</label>
                    <span className="htBold">일반반(사각간)</span>

                </div> */}
                <div className="htSeparator mt-1"></div>
                <button
                    className="htSubmitButton"
                    onClick={() => {
                        dispatch(setAppLoading(true));
                        sendEvidencePaper();
                        // navigate("/parking_check");
                    }}>입차증 발급</button>
                <ButtonBot textYes={`주차상황판`} handleYes={() => { navigation("/parking_status") }} />
            </div>
            {showPopupAlertUnpaid && (
                <Popup
                    title="알림"
                    handleYes={() => setShowPopupAlertUnpaid(false)}
                    textYes="확인"
                    setVisible={setShowPopupAlertUnpaid}
                >
                    <div className="nl-row f-column">
                        <div>미납 내역이 있습니다.</div>
                    </div>

                </Popup>
            )}
        </div>

    );
}

export default ParkingCheckResult;
